export const TX_ID_STRING_LIST = 'txIdStringList';
export const TX_ID_LIST = 'txIdList';
export const OBJ_HASH = 'objHash';
export const TX_ID = 'txid';
export const TX_ID_STRING = 'txidString';
export const GX_ID = 'gxid';
export const GX_ID_STRING = 'gxidString';
export const START_DATETIME = 'startDatetime';
export const END_DATETIME = 'endDatetime';

export const transactionTooltipValueMap = {
  1: '~5s',
  2: '~10s',
  3: '~20s',
  4: '~40s',
  5: '~80s',
  6: '~160s',
};

export const transactionTooltipTimeMap = {
  1: '2분 간격',
  2: '10분 간격',
  3: '30분 간격',
  4: '60분 간격',
  5: '120분 간격',
};



// WEBPACK FOOTER //
// ./src/constants/apm-domain-define.js